// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1RrE4","searchInput":"styles_searchInput__1CDtY","tags":"styles_tags__1mM9D","newTag":"styles_newTag__3kIlz","alert":"styles_alert__22nGk"};